// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'disable',
    'aws_cognito_identity_pool_id': 'us-east-1:613bf68c-6ac6-48cc-957d-732875e1c922',
    'aws_cognito_region': 'us-east-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'analyticsdev-hosting-mobilehub-717249914',
    'aws_content_delivery_bucket_region': 'us-east-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd2s62p0sf7dtfd.cloudfront.net',
    'aws_project_id': '74c56e41-696a-4428-927f-53970101f6de',
    'aws_project_name': 'analytics-dev',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'analyticsdev-mobilehub-717249914',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'analyticsdev-userfiles-mobilehub-717249914',
    'aws_user_files_s3_bucket_region': 'us-east-1',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_rd1Vqq5FR',
    'aws_user_pools_mfa_type': 'OFF',
    'aws_user_pools_web_client_id': '56g64sil1o381ilchs3vb8q4r4',
    'aws_appsync_graphqlEndpoint': 'https://dtl2b2f7sjf2dfhqlirebkjyuu.appsync-api.us-east-1.amazonaws.com/graphql',
    'aws_appsync_region': 'us-east-1',
    'aws_appsync_authenticationType': 'API_KEY',
    'aws_appsync_apiKey': 'da2-5ueea2n5ffambm6at45mqczhtm',
}

export default awsmobile;
